import { FadeIn } from "~/components/FadeIn";

// // // //

export function AuthPageLayout(props: { children: React.ReactNode }) {
    return (
        <div className="relative flex min-h-[calc(100vh-4rem)] grow flex-col justify-center overflow-hidden bg-background-02 px-4 py-10 select-none sm:px-6 sm:py-14 lg:px-8">
            <FadeIn>
                <div className="relative z-10 mx-auto flex w-full max-w-[420px] justify-center">
                    {props.children}
                </div>
            </FadeIn>
        </div>
    );
}
